/** Page numbers around the current page, with gaps collapsed to an ellipsis marker. */
export const pageWindow = (page: number, pages: number): Array<number | 'gap'> => {
  const keep = new Set([0, pages - 1, page - 1, page, page + 1].filter((p) => p >= 0 && p < pages));
  const out: Array<number | 'gap'> = [];
  let prev = -1;
  Array.from(keep)
    .sort((a, b) => a - b)
    .forEach((p) => {
      if (p - prev > 1) out.push('gap');
      out.push(p);
      prev = p;
    });
  return out;
};
